import StickyBanner from "components/Common/StickyBanner";
import { BusinessStatus } from "enum/common";

interface IBusinessDeactivationReasonProps {
  business: BusinessType;
}
const BusinessDeactivationReason: React.FC<
  IBusinessDeactivationReasonProps
> = ({ business }) => {
  const renderDeactivationReason = () => {
    switch (business?.businessStatus) {
      case BusinessStatus.DE_ACTIVATED:
        return (
          <StickyBanner customClass="bg-failed pt-2">
            <div
              dangerouslySetInnerHTML={{
                __html: business?.businessStatusMessage,
              }}
            />
          </StickyBanner>
        );
      case BusinessStatus.PARTIALLY_DEACTIVATED || BusinessStatus.IN_ACTIVE:
        return (
          <StickyBanner customClass="bg-brightOrange pt-2">
            <div
              dangerouslySetInnerHTML={{
                __html: business?.businessStatusMessage,
              }}
            />
          </StickyBanner>
        );
      default:
        return (<StickyBanner customClass="bg-failed pt-2">
          <div
            dangerouslySetInnerHTML={{
              __html: business?.businessStatusMessage,
            }}
          />
        </StickyBanner>);
    }
  };

  return <div>{renderDeactivationReason()}</div>;
};

export default BusinessDeactivationReason;
